(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["smallies-product-card"] && !Shopify.designMode) return;
  try {
    // Open the cart drawer after "Add to Bag", as the product page does. The theme's own
  // auto-open setting is off; this only answers adds that come from a card.
  document.addEventListener('shopify:cart:lines-update', (event) => {
    if (event.action !== 'add' || !(event.target instanceof Element) || !event.target.closest('.smallies-card')) return;

    event.promise?.then(({ detail }) => {
      const drawer = document.getElementById('cart-drawer');
      if (detail?.didError || !drawer || drawer.isOpen) return;
      drawer.open();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
